window.addEventListener('DOMContentLoaded', function() {
    // Code to run when the document is ready
    let intake_quiz_results_string = sessionStorage.getItem('intakeQuizResults');
    let intake_quiz_results = false;
    if(intake_quiz_results_string){
        intake_quiz_results = JSON.parse(intake_quiz_results_string);
    }
    if(intake_quiz_results){
        let weight_bmi = intake_quiz_results['my_bmi'];
        let cal_intake = intake_quiz_results['daily_calories'];
        let water_intake = intake_quiz_results['daily_water'];
        let bmi_class = intake_quiz_results['my_bmi_class'];
        if(weight_bmi && cal_intake && water_intake){
            document.querySelector('.daily-intake__water').textContent = water_intake;
            document.querySelector('.daily-intake__calorie').textContent = cal_intake;
            document.querySelector('.weight-value__' + bmi_class).style.display = "block";
            document.querySelector('.weight-value__' + bmi_class + ' span').textContent = weight_bmi;
            document.querySelector('.weight-row__' + bmi_class).classList.add('weight-selected');
            let requestSent = sessionStorage.getItem('requestSent');
            if(requestSent == "false"){
                let userAnswers = sessionStorage.getItem('userAnswers');
                composePlan(userAnswers, intake_quiz_results_string);
            }
        }else{ 
            // window.location.href = "/pages/clovis-intake-quiz";
        }
    }else{
        // window.location.href = "/pages/clovis-intake-quiz";
    }
}); 
function composePlan(userAnswers, quizResults){
    
fetch('https://clovis-custom-plan.iamclovis.com/composePlan', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json'
    },
    body: JSON.stringify({
        userAnswers: userAnswers,
        quizResults: quizResults,
        themeId: Shopify.theme.id
    }),
    mode: 'cors'
})
.then(response => {
    sessionStorage.setItem('requestSent', 'true');
})
.catch(error => console.error('Error:', error));

}